export default __webpack_public_path__ + "static/media/Montserrat-ExtraLight.62a749ca.ttf";